import {
  AppMode, LayerInfo,
  MapInfo, OtherLegendSpec,
  LayerHierarchy,
  LayerVariabilityType,
  MapCommand,
  LayerType,
} from '../common/managers/Types';
import { PersistenceObjectType, PersistenceScope, SessionContext, Utils, ViamapPersistenceLayer } from '@viamap/viamap2-common';

import { Localization, SettingsManager } from "@viamap/viamap2-common";
import { GenerateGeom } from '../managers/GenerateGeom';
import { Logger } from '@viamap/viamap2-common';
import { Persistence } from '../managers/Persistence';
import { CatchmentInterface } from '../managers/CatchmentInterface';
import { LayerFunc } from '../managers/LayerFunc';
import Catchment from '../svg/catchment/catchment.svg?react'

import { Legend } from './Legend';
import { parse as WKTParse } from 'wkt';

import { CustomerLogo } from './CustomerLogo';
import { Image } from 'react-bootstrap';

import { PropertyInfoInterface } from '../managers/PropertyInfoInterface';

import { FileImportContext } from './FileImporter';
import { FileImportType } from "./FileImportHooks";
import CookieApproval from './CookieApproval';
import { MitEvent, MitLatLng, MitMap } from 'src/managers/MapFacade';
import { actionAddDataLayer, actionRemoveDataLayer, actionSetFeatureLayerVisibility, MapInteractionState, MapitStateActionType, MapitStateContext, actionSetViewPoi, actionAddPopup, MitPopup, actionSetMapInteractionStateDefault, actionClosePopups, actionSetMapInteractionState, DataDrivenBackgroundLayer } from 'src/states/MapitState';
import { useContext, useEffect, useRef, useState } from 'react';
import { actionClearInfoMessage, actionSetErrorMessage, actionSetInfoMessage, AppMessagesContext } from '@viamap/viamap2-common';
import { AddressInterface } from 'src/managers/AddressInterface';
import { ApplicationStateContext, Feature } from 'src/states/ApplicationState';
import { AreaPopup, LinePopup, PointInfoPopup, PointPopup, VectorLayerPopup } from './MapPopup';
import { LegendScaleForCatchment } from './LegendScaleForCatchment';
import { FeatureLayer, FeatureLayerList } from 'src/managers/WmsLayerFunc';
import { CatchmentStateContext, MessageType, actionGenerateCatchmentSimple } from 'src/states/CatchmentState';
import { MitStorage } from 'src/managers/MitStorage';
import { DynamicDataDrivenLayerFunc } from 'src/managers/DynamicDataDrivenLayer';
import { VectorLayer } from 'src/managers/VectorLayerFunc';
import { executeCommand } from 'src/managers/RestoreMapLink';
import { StatusUp } from 'iconsax-react';
import { createPortal } from 'react-dom';
import { GeoJSONSource, Point } from 'maplibre-gl';
import { GeojsonWFS } from 'src/managers/WFSGeojsonLayerFunc';
import { useWindowContext } from 'src/WindowManager/useWindowContext';
import { closeWindow, openWindow, WindowId } from 'src/WindowManager/WindowState';
import { message } from './Message';
import { MapFacadeMaplibre } from 'src/managers/MapFacadeMaplibre';
import { EjerlavCache } from 'src/managers/EjerlavCache';
import { circle } from '@turf/turf';
import { FRPLegendList } from 'src/modules/FRPModule/FRPLegendDialog';
import { JPBLegendList } from 'src/modules/JPBModule/JPBLegend';
import { OnMapButton } from './GlassButtons';
import { StatTracker } from 'src/common/managers/StatTracker';
import { ActionTracker } from 'src/common/managers/ActionTracker';
import { DC } from 'src/dataCollector/DataCollector';
import { MIBIcon } from 'src/componentsUtils/MIBIcon';

type Props = {
  callbackToLogout: () => any;
  showTrialSignupDialog: boolean;
  callBackOnTrialSignup: (name: string, company: string, phoneNo: string, termsApproved: boolean) => void;
  callBackMap: (a: any) => any;
  mapReference?: string
  commandList?: MapCommand[]
};

export type LayerChangeAction =
  | "Add"
  | "Remove"
  | "Update"
  | "Styling"
  | "Toggle"
  | "MetaData"
  | "Hide"
  | "Show"

export const MapScreen = (props: Props) => {
  const { dispatch: appMessageDispatch } = useContext(AppMessagesContext);
  const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
  const { importCallBack: fileDipatch } = useContext(FileImportContext);
  const { state: sessionState } = useContext(SessionContext);
  const { state: applicationState, hasAccessToFeature } = useContext(ApplicationStateContext);
  const { state: catchmentState, dispatch: catchmentStateDispatch } = useContext(CatchmentStateContext);
  const poiRef = useRef<number | null>(null);
  const { state: windowState, dispatch: windowDispatch } = useWindowContext()

  const mapContainer = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (catchmentState.messageType === MessageType.Error) {
      message.error(catchmentState.message);
    }
  }, [catchmentState.message, catchmentState.messageType])

  useEffect(() => {
    if (mapContainer.current) {


      let map = new MapFacadeMaplibre(mapContainer.current, false, { mapStyle: mapitState.mapInfo.mapStyle });
      mapitStateDispatch({ type: MapitStateActionType.SetMapObjectRef, payload: { item: map as any } });
      // GENERAL ERROR HANDLER
      document.body.addEventListener(
        'mit-error-handler',
        (e: any) => {
          if (e.detail) {
            Logger.logError("MapScreen", "mit-error-handler", e.detail);
          }
          appMessageDispatch(actionSetErrorMessage(e.detail));
        }
      );

      // GENERAL INFO MESSAGE HANDLER
      document.body.addEventListener(
        'mit-info-handler',
        (e: any) => {
          if (e.detail) {
            Logger.logInfo("MapScreen", "mit-info-handler", e.detail);
          }
          appMessageDispatch(actionSetInfoMessage(e.detail));
        }
      );

      GenerateGeom.setupBaseData();
      mapitStateDispatch({ type: MapitStateActionType.InitializeStandardLayers, payload: { hasAccessToFeatureFunction: hasAccessToFeature } });
      props.callBackMap(map);


      // Warn user before closing the window - unless in special modes
      if (!(
        Utils.isDevelopmentBuild() ||
        Utils.isTestBuild() ||
        applicationState.appMode === AppMode.ReadOnly ||
        applicationState.appMode === AppMode.Embedded
      )) {
        // If in normal mode: enable warning
        window.onbeforeunload = closeIt;
      }

      map.on('move', () => {
        const popBox = document.getElementById("FillExtrusionDetail")
        if (popBox)
          popBox.style.display = "none"
      })

      map.on('moveend', () => {
        if (map.getZoom() >= SettingsManager.getSystemSetting("MaxZoomPoi", 12, true) !== mapitStateRef.current.viewPoi) {
          mapitStateDispatch(actionSetViewPoi(map.getZoom() >= SettingsManager.getSystemSetting("MaxZoomPoi", 12, true)))
        }
        updateDataForVisibleArea();
      })
      map.on('load', () => {
        updateDataForVisibleArea();
        console.info(">> done <<")
      })
      map.once('load', () => {
        if (hasAccessToFeature(Feature.ViewCustomFeatureLayers)) {
          loadCustomFeatureLayers();
        }
        let featureL = mapitStateRef.current.featureLayers;
        let defautlLayers = Object.keys(featureL).filter((a) => featureL[a].layer.activeByDefault).map((a) => featureL[a].layer.label)
        let rememberedLayers = SettingsManager.getSystemSetting("SaveOpendedFeatureLayers") && MitStorage.getValue<[]>("MIT-SelectedLayers") || [];
        let rememberedGroupUUIDs = SettingsManager.getSystemSetting("SaveOpendedFeatureLayers") && MitStorage.getValue<[]>("MIT-SelectedGroupUUIDs") || [];

        ([...defautlLayers, ...rememberedLayers]).forEach((layerKey) => {
          mapitStateDispatch(actionSetFeatureLayerVisibility(layerKey, true, [{ key: layerKey }]));
        })

        if (rememberedGroupUUIDs.length > 0 && hasAccessToFeature(Feature.FavoriteBackgroundLayers)) {
          loadAndRestoreCustomGroups(rememberedGroupUUIDs);
        }
        mapitStateDispatch({ type: MapitStateActionType.Restore })
        if (props.commandList?.length) {
          executeCommand(props.commandList, (a: LayerChangeAction, b: LayerInfo, c: boolean) => {
            switch (a) {
              case "Add":
                mapitStateDispatch(actionAddDataLayer({ ...b, readonly: true }, c))
                break;

              default:
                console.error("Unknown LayerChangeAction")
                break;
            }
          })
        }
        map.getCanvas().addEventListener('paste', async (e) => {
          e.preventDefault();
          try {
            let clipboardData = await navigator.clipboard.readText();
            let jsonOBJ = safeJSONParse(clipboardData) ?? {};
            let feature = validGeojson(jsonOBJ) ? jsonOBJ : WKTParse(clipboardData);
            if (feature.type !== "FeatureCollection" && feature.type !== "Feature") {
              feature = { type: "Feature", geometry: feature, properties: {} };
            }
            if (feature.type !== "FeatureCollection") {
              feature = { type: "FeatureCollection", features: [feature] }
            }
            Persistence.createLayersFromGeoJSON("From Clipboard", feature, new Date(), (li: LayerInfo) => {
              console.log(li);
              mapitStateDispatch({
                type: MapitStateActionType.AddDataLayer, payload: { layerInfo: li, zoomToFocus: true }
              });
            });
          } catch {
            console.warn("Error geometry")
          }
        })
      })

      if (props.mapReference && !props.commandList?.length) {
        fileDipatch({
          fileImportType: FileImportType.FileFetch,
          url: props.mapReference,
        })
      }

      // Control should Match position of Mit-MapOverlay
      const matchMitMapOverlay = () => {
        if (mapContainer.current) {
          let control = [...mapContainer.current.getElementsByClassName("maplibregl-control-container")][0] as HTMLDivElement
          let overlay = document.getElementById("Mit-NonBlockingOverlay")
          if (control && overlay) {
            const { top, left, width, height } = overlay.getBoundingClientRect()
            control.style.position = "absolute"
            control.style.height = height + "px"
            control.style.left = left + "px"
            control.style.width = width + "px"
            control.style.top = top + "px"
          }
        }
      }
      const resizeObserver = new ResizeObserver(matchMitMapOverlay)
      const overlay = document.getElementById("Mit-MapOverlay")
      if (overlay) {
        resizeObserver.observe(overlay)
      }
      matchMitMapOverlay()

    }

  }, []);

  let mapitStateRef = useRef(mapitState);
  useEffect(() => {
    mapitStateRef.current = mapitState;
  }, [mapitState]);

  useEffect(() => {
    if (mapitStateRef.current.map) {
      updateDataForVisibleArea();
    }


  }, [mapitState.poiTypesToShow])

  useEffect(() => {
    mapitStateDispatch({ type: MapitStateActionType.InitializeStandardLayers, payload: { hasAccessToFeatureFunction: hasAccessToFeature } });
  }, [applicationState.availableFeatures])

  useEffect(() => {
    let map = mapitState.map as any
    if (map == 1 || map == undefined) {
      return
    }

    map.on('click', onMapClick);

    const delayedStart = (e) => {
      if (e.defaultPrevented) {
        return
      }
      const preventTouchOnMove = () => {
        map.off('touchend', onMapClick)
        map.off('move', preventTouchOnMove)
      }
      map.on('touchend', onMapClick)
      map.on('move', preventTouchOnMove)
      setTimeout(() => {
        map.off('touchend', onMapClick)
      }, 200)
    }
    map.on('touchstart', delayedStart);

    map.on('mousemove', "poi-unclustered-icon", (e) => {

      if (poiRef.current !== null) {
        map.setFeatureState({ source: e.features[0].source, id: poiRef.current }, { hover: false })
      }
      if (e.features.length > 0) {
        map.setFeatureState({ source: e.features[0].source, id: e.features[0].id }, { hover: true })
        poiRef.current = e.features[0].id
      }
    })
    map.on('touchstart', "poi-unclustered-icon", (e) => {
      e.preventDefault()
      if (poiRef.current !== null) {
        map.setFeatureState({ source: e.features[0].source, id: poiRef.current }, { hover: false })
      }
      if (e.features.length > 0) {
        map.setFeatureState({ source: e.features[0].source, id: e.features[0].id }, { hover: true })
        poiRef.current = e.features[0].id
      }
    })
    map.on('mouseleave', "poi-unclustered-icon", () => {
      if (poiRef.current !== null) {
        map.setFeatureState({ source: "poi-source-1", id: poiRef.current }, { hover: false })
        poiRef.current = null
      }
    })

    return () => {
      map.off('click', onMapClick)
      map.off('touchstart', delayedStart)
    }


  }, [hasAccessToFeature, mapitState.map])

  useEffect(() => {
    let map = mapitState.map as any
    if (map == 1 || map == undefined) {
      return
    }
    if (mapitState.selectedFeatureLayerKeys.length && (mapitState.mapInteractionState === MapInteractionState.ZoomedIn || mapitState.mapInteractionState === MapInteractionState.NSZoomedIn)) {
      mapitStateDispatch(actionSetMapInteractionState(MapInteractionState.Normal))
      return
    }
    if (mapitState.selectedFeatureLayerKeys.length) {
      return
    }

    function MoveZoomedInd() {
      if (mapitState.mapInteractionState === MapInteractionState.Normal) {
        if (map.getZoom() > SettingsManager.getSystemSetting("mapInteractionStateZoomedIn")) {
          if (hasAccessToFeature(Feature.ThemeNewSec)) {
            mapitStateDispatch(actionSetMapInteractionState(MapInteractionState.NSZoomedIn))
          } else if (SettingsManager.getSystemSetting("showPropertyInfoOnClick")) {
            mapitStateDispatch(actionSetMapInteractionState(MapInteractionState.ZoomedIn))
          }
        }
      } else if (mapitState.mapInteractionState === MapInteractionState.ZoomedIn) {
        if (map.getZoom() < SettingsManager.getSystemSetting("mapInteractionStateZoomedIn")) {
          mapitStateDispatch(actionSetMapInteractionState(MapInteractionState.Normal))
        }
      } else if (mapitState.mapInteractionState === MapInteractionState.NSZoomedIn) {
        if (map.getZoom() < SettingsManager.getSystemSetting("mapInteractionStateZoomedIn")) {
          mapitStateDispatch(actionSetMapInteractionState(MapInteractionState.Normal))
        }
      }
    }
    map.on('moveend', MoveZoomedInd)
    return () => map.off('moveend', MoveZoomedInd)
  }, [mapitState.map, mapitState.mapInteractionState, mapitState.selectedFeatureLayerKeys])

  useEffect(() => {
    let urlToLabels = Object.values(mapitState.featureLayers).map((a) => ({
      urlIdent: a.layer.host + "|" + a.layer.layers,
      label: a.layer?.translationTable ? Localization.getTextSpecificTable(a.layer.label, a.layer?.translationTable) : a.layer.label,
      x: Math.random(), y: Math.random()
    }))
    mapitState.map?.setUrlToLabels?.(urlToLabels);
  }, [mapitState.map, mapitState.featureLayers])



  useEffect(() => {
    let registeretEvents: { a: string, b: any, type: string }[] = []
    if (mapitState.mapInteractionState === MapInteractionState.EnforceFeatureLayerPopup) {
      mapitState.map.getCanvas().style.cursor = "crosshair"
      return () => {
        mapitState.map.getCanvas().style.cursor = ""
      }
    } else if (mapitState.mapInteractionState === MapInteractionState.Normal) {

      const vectorLayers = mapitState.selectedFeatureLayerKeys.filter((a) => {
        return (mapitState.featureLayers[a] instanceof VectorLayer || mapitState.featureLayers[a] instanceof GeojsonWFS)
      }).map((a) => { return { id: (mapitState.featureLayers[a] as VectorLayer).getLayerID(0) } })
      const layerList = Object.keys(mapitState.layers).flatMap((layerID) => {
        const layerInfo = mapitState.layers[layerID]
        if (layerInfo?.handle?.layerList) {
          return [...layerInfo.handle.layerList]
        }
      });

      [...layerList || [], ...vectorLayers || []].filter((a) => a.id).forEach(element => {


        function enterHandler(e) {
          e.target.getCanvasContainer().style.cursor = "pointer"
        }
        function leaveHandler(e) {
          e.target.getCanvasContainer().style.cursor = ""
          if (element.id.includes("fill-extrusion")) {
            const popBox = document.getElementById("FillExtrusionDetail")
            if (popBox) popBox.style.display = "none";
          }
        }

        function mouseMove(e) {

          function LayerInfoFromSourceID(sourceId: string) {
            return Object.values(mapitStateRef.current.layers).find((layerInfo) =>
              layerInfo.handle.sourceId == sourceId
            )
          }

          let layerId = LayerInfoFromSourceID(e.features[0].source)
          let props = e.features[0].properties
          let display = layerId?.propertiesToDisplay



          const div = document.createElement("div");
          div.className = "propsList";

          display?.map((a) => a.name).forEach((a) => {
            if (props[a]) {

              const line = document.createElement("div")
              const val = document.createElement("div")
              const key = document.createElement("div")
              key.innerText = a
              val.innerText = props[a]
              line.appendChild(key)
              line.appendChild(val)
              div.appendChild(line)
            }
          })

          const { x, y } = e.point as { x: number, y: number }

          const popBox = document.getElementById("FillExtrusionDetail")
          if (popBox) {
            popBox.innerHTML = "";
            popBox.appendChild(div);
            popBox.style.top = y + "px";
            popBox.style.left = x + "px";
            popBox.style.display = "block";
          }
        }
        if (element.id.includes("fill-extrusion")) {
          mapitState.map.on('mousemove', element.id, mouseMove)
          registeretEvents.push({ a: element.id, b: mouseMove, type: 'mousemove' })
        }

        mapitState.map.on('mouseenter', element.id, enterHandler)
        registeretEvents.push({ a: element.id, b: enterHandler, type: 'mouseenter' })

        mapitState.map.on('mouseleave', element.id, leaveHandler)
        registeretEvents.push({ a: element.id, b: leaveHandler, type: 'mouseleave' })
      });


      return () => { registeretEvents.map(a => mapitState.map.off(a.type, a.a, a.b)) }
    } else {
      mapitState.map.getCanvas().style.cursor = "pointer"
      return () => {
        mapitState.map.getCanvas().style.cursor = ""
      }
    }
  }, [mapitState.layers, mapitState.selectedFeatureLayerKeys, mapitState.mapInteractionState, mapitState.mapInfo])

  useEffect(() => {
    let registeretEvents: any[] = []
    Object.values(mapitState.layers).forEach(element => {
      if ((element.unlocked)) {
        let gj = element.geoJson.features
        var id = 0;
        async function onMove(e) {
          const coords = e.lngLat
          if (id !== undefined) {
            gj[id] = {
              ...gj[id], geometry: {
                ...gj[id].geometry,
                coordinates: [coords.lng, coords.lat]
              }
            };
            let mapLayer = await (mapitState.map.getMapPop().getSource(element.handle.sourceId) as GeoJSONSource)?.getData() as any;
            if ((mapLayer as any)?.features.length) {
              mapLayer.features[id] = { ...mapLayer.features[id], geometry: gj[id].geometry };
              if (element.type === LayerType.GeoJSON_PointRadius) {
                mapLayer.features[id] = circle(gj[id], element.styling.circleRadius || 100, { steps: element.styling.circleSteps || 32, units: 'meters' })
                mapLayer.features[id].id = id
              }
              (mapitState.map.getMapPop().getSource(element.handle.sourceId) as GeoJSONSource)?.setData(mapLayer);
            }
          }
        }

        function onUp() {
          mapitState.map.off('mousemove', onMove)
        }

        function onDown(e) {
          id = e.features[0].id
          e.preventDefault();
          mapitState.map.on('mousemove', onMove)
          mapitState.map.once('mouseup', onUp)
        }
        mapitState.map.on('mousedown', element.handle.layerList[0].id, onDown)
        registeretEvents.push({ a: element.handle.layerList[0].id, b: onDown, type: 'mousedown' })
      }
    });
    return () => { registeretEvents.map(a => mapitState.map.off(a.type, a.a, a.b)) }
  }, [mapitState.layers])

  let mapInteractionStateRef = useRef(mapitState.mapInteractionState);
  useEffect(() => {
    mapInteractionStateRef.current = mapitState.mapInteractionState
  }, [mapitState.mapInteractionState])

  function updateDataForVisibleArea() {
    // Refresh any POIs
    GenerateGeom.AsyncDisplayPOIforBounds(mapitStateRef.current.map, mapitStateRef.current.poiLayerHandle, mapitStateRef.current.poiTypesToShow);

    // Refresh any (other) data driven layers
    if (mapitStateRef.current.map && (typeof mapitStateRef.current.map === 'object') && mapitStateRef.current.map.isInitialized()) {
      if (mapitStateRef.current.EsDrivenLayers && mapitStateRef.current.EsDrivenLayers.length > 0) {
        mapitStateRef.current.EsDrivenLayers.forEach(async (ddl: DataDrivenBackgroundLayer) => {
          (new DynamicDataDrivenLayerFunc()).OnMoveHandler(mapitStateRef.current.map, ddl.onMove);
          return
        })
      }
    }
  }


  /**
   * Loads all the custom feature layers stored in the user's domain's AWS configuration
   */
  async function loadCustomFeatureLayers(): Promise<void> {
    let domainName = sessionState.customerRef;
    if (domainName === "" || Object.values(mapitState.layers).filter((a) => a.layerVariability == LayerVariabilityType.FixedFeatureLayer).length) {
      return
    }

    let persit = new ViamapPersistenceLayer(SettingsManager.getSystemSetting("viamapStoreS3Bucket"))
    // let prefixPath = "customerConfig/" + domainName + "/customLayers/";
    let prefixPath = persit.createPrefix(PersistenceScope.Customer, PersistenceObjectType.SavedMaps, domainName)
    let filesInFolder = await persit.getListingS3(prefixPath)
    filesInFolder.filter((a) => {
      return a.Key.includes(".mapit") || a.Key.includes(".estateExplorer")
    }).forEach(async (fileObj) => {
      let FileData = await persit.getObjectS3(fileObj.Key)
      let CurFeatureL = JSON.parse(FileData.Body.toString())
      if (CurFeatureL.mapSettings?.template) {
        return
      }
      let layerRenumberingMap: { [key: number]: number } = {};
      (CurFeatureL.layers as LayerInfo[] ?? []).forEach(layer => {
        let createdID = Math.round(Math.random() * 10000000) + 1000;
        layerRenumberingMap[layer.layerId] = createdID;
      });
      let newLayer = (CurFeatureL.layerHierarchy && { ...CurFeatureL.layerHierarchy }) || {
        id: 0,
        name: "Top Level",
        isCollapsed: false,
        children: Object.keys(layerRenumberingMap).map((a) => ({ id: a, children: [] }))
      }
      let newLayerHierachy = { ...newLayer, children: [{ readonly: true, id: -10000, isCollapsed: true, name: (CurFeatureL.mapInfo?.mapTitle || CurFeatureL.awsFilename), children: newLayer.children }] };
      let groupIdObject = GetFlatGroupFrom(newLayerHierachy, []);
      await Persistence.createLayersFromJSON(
        CurFeatureL,
        new Date(),
        () => { return },
        () => { return },
        (layer) => {
          let nextLayerID = layerRenumberingMap[layer.layerId] ||= Math.round(Math.random() * 10000000) + 1000;
          let obj: LayerInfo = {
            ...layer,
            group: [(layer.awsFilename ?? fileObj.Key.split("/").at(-1))].concat(groupIdObject[layer.layerId]).filter((a) => a),
            layerId: nextLayerID,
            readonly: true,
            layerVariability: LayerVariabilityType.FixedFeatureLayer,
            visible: false,
          }
          addALayer(mapitState.map, obj, false);
          return layer.layerId
        },
        () => { return }
      )
    })

  }

  /**
   * Loads and restores custom groups by their UUIDs
   */
  async function loadAndRestoreCustomGroups(groupUUIDs: string[]): Promise<void> {
    try {
      const CFLGFileName = "CutomFeatureLayersGroups.json";
      let persist = new ViamapPersistenceLayer(SettingsManager.getSystemSetting("viamapStoreS3Bucket"));

      const userGroups = await persist.getObject(PersistenceScope.User, PersistenceObjectType.CustomLayers, sessionState.customerRef, sessionState.userRef, CFLGFileName)
        .then((a) => {
          let str = a.Body.toString("utf-8");
          return [...JSON.parse(str)].map((a) => ({ ...a, online: false }));
        })
        .catch(() => []);

      const onlineGroups = await persist.getListing(PersistenceScope.Customer, PersistenceObjectType.CustomLayers, sessionState.customerRef, sessionState.userRef)
        .then(async (a) => {
          const x = (await Promise.all(a.map(async (a) => {
            return await persist.getObjectS3(a.Key).then((b) => {
              let str = b.Body.toString("utf-8");
              let obj = JSON.parse(str);
              if (obj.uuid && obj.title && obj.bgLayer && obj.layers) {
                return { ...obj, online: true };
              }
              return null;
            }).catch(() => null);
          }))).filter((a) => a);
          return x;
        })
        .catch(() => []);

      const allGroups = [...onlineGroups, ...userGroups];

      groupUUIDs.forEach((groupUUID) => {
        const group = allGroups.find(g => g.uuid === groupUUID);
        if (group) {
          console.log("Found group to restore:", group.title, "with layers:", group.layers);
          const layersWithSpecs = group.layers.map((layerKey) => {
            const prefixedKey = `\\${groupUUID}\\${layerKey}`;
            return {
              key: prefixedKey,
              layer: group.layerSpecs?.[layerKey]
            };
          });

          console.log("Activating group with layers:", layersWithSpecs);
          mapitStateDispatch(actionSetFeatureLayerVisibility(group.title, true, layersWithSpecs));
        } else {
          console.log("Group not found for UUID:", groupUUID);
        }
      });
    } catch (error) {
      console.error("Error loading custom groups for restoration:", error);
    }
  }

  function ZoomPointViewAble(lng, lat) {
    if (
      window.innerWidth > 500 ||
      window.innerHeight > 800
    ) {
      return
    }

    const map = mapitState.map.getMapPop();
    let overlay = document.getElementById("Mit-NonBlockingOverlay") as HTMLDivElement
    let extraTopping = parseInt(window.getComputedStyle(overlay).getPropertyValue("--NonBlockTopSpace"))
    const wWidth = window.innerWidth;
    const wHeight = window.innerHeight;
    const { left, width, height } = overlay.getBoundingClientRect();

    const right = wWidth - (width + left)
    const horizontalOffset = (left - right) / 2;


    // Magic numbers, [PopupHeader, PopupTip, PopupOffset, NavigationBar]
    const verticalOffset = (wHeight - height) - (30 + 10 + 10 + extraTopping)

    let { x, y } = map.project([lng, lat])


    let pLngLat = map.unproject(new Point(x - horizontalOffset, y + verticalOffset))

    map.flyTo({
      center: pLngLat,
      curve: 1,
      speed: 1,
    });
  }

  function GetFlatGroupFrom(hierarchy: LayerHierarchy, curentIndex: string[]): { [layerId: number]: string[] } {
    let result: { [layerId: number]: string[] } = {}
    if (hierarchy?.children?.length == undefined || hierarchy.children.length === 0) {
      return { [hierarchy.id]: curentIndex }
    } else {
      (hierarchy.children as LayerHierarchy[]).forEach((child: LayerHierarchy) => {
        result = { ...result, ...GetFlatGroupFrom(child, [...curentIndex, child.name]) }
      });
    }
    return result
  }

  type MitEventExtended = MitEvent & {
    preventDefault: () => void
  }
  async function onMapClick(e: MitEventExtended) {
    if (mapitState.map) {
      mapitStateDispatch(actionClosePopups(true))
      switch (mapInteractionStateRef.current) {
        case MapInteractionState.ClickToSetMarker: {
          StatTracker.count("MapInteraction", "ClickToSetMarker");
          ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToSetMarker", { coord: [e.lngLat.lat, e.lngLat.lng] });
          if (!e.originalEvent.ctrlKey)
            mapitStateDispatch(actionSetMapInteractionStateDefault());
          if (hasAccessToFeature(Feature.ThemeNewSec)) {
            let latLng = new MitLatLng(e.lngLat.lat, e.lngLat.lng)
            let resp = await AddressInterface.reverseGeocode(e.lngLat.lat, e.lngLat.lng);
            let addrData = await resp.json();
            let fullAddress = addrData.betegnelse;
            let tmp = fullAddress.split(',');
            let streetAndNumber = tmp[0] || fullAddress;
            let layerInfo = LayerFunc.createLayerInfoForOnePoint(latLng, streetAndNumber);
            mapitStateDispatch(actionAddDataLayer(layerInfo, false, true));
            DataLayerClickFunction({ ...e, features: [{ geometry: { type: "Point" } }] }, mapitState.mapInfo, layerInfo, (b) => mapitStateDispatch(actionAddPopup(MitLatLng.fromM(e.lngLat), (b), true)))
          } else {
            let name = Localization.getText("New Point")
            let data = {};
            try {
              let resp = await AddressInterface.reverseGeocode(e.lngLat.lat, e.lngLat.lng)
              let addrData = await resp.json();

              if (resp.status == 200 && addrData) {
                let fullAddress = addrData.betegnelse;
                let tmp = fullAddress.split(',');
                let streetAndNumber = tmp[0] || fullAddress;
                let zipAndCity = addrData.postnr + " " + addrData.postnrnavn;
                let utmCoords = GenerateGeom.convertFromLatLngToUTM({ ...e.lngLat });
                let matData = (await PropertyInfoInterface.getMatrikelData(utmCoords))?.features[0]?.properties;
                data = matData.matrikelnummer && { "Navn": streetAndNumber, "Postnummer": zipAndCity, "Kommunekode": addrData.kommunekode }
                name = (matData.matrikelnummer && streetAndNumber) || name
              }
            } catch (error) {
              console.warn("Error reverse geocoding:", error)
            }
            let layerInfo = LayerFunc.createLayerInfoForOnePoint(new MitLatLng(e.lngLat.lat, e.lngLat.lng), name, data);
            mapitStateDispatch(actionAddDataLayer(layerInfo, false, true));
            // revert to inactive mode after the first point is clicked
          }
          break;
        }
        case MapInteractionState.ClickToShowObliquePhotos: {
          StatTracker.count("MapInteraction", "ClickToShowObliquePhotos");
          ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToShowObliquePhotos", { coord: [e.lngLat.lat, e.lngLat.lng] });
          windowDispatch(openWindow(WindowId.ObliqueViewer, { latlng: new MitLatLng(e.lngLat.lat, e.lngLat.lng) }))
          break;
        }
        case MapInteractionState.ClickToShowPropertyInfo: {
          StatTracker.count("MapInteraction", "ClickToShowPropertyInfo");
          ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToShowPropertyInfo", { coord: [e.lngLat.lat, e.lngLat.lng] });
          let bfeData = await DC.WFS.Utils.bfeUnderPoint([e.lngLat.lng, e.lngLat.lat]);
          windowDispatch(openWindow(WindowId.PropertyInformationDialog, { bfeNr: bfeData?.sfeNr, ejerlavskode: bfeData?.ejerl, matrnr: bfeData?.matnr }));
          break;
        }
        case MapInteractionState.ClickToShowStreetView: {
          StatTracker.count("MapInteraction", "ClickToShowStreetView");
          ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToShowStreetView", { coord: [e.lngLat.lat, e.lngLat.lng] });
          windowDispatch(openWindow(WindowId.StreetView, e.lngLat));
          break;
        }
        case MapInteractionState.ClickToShowTravelTimePolygons: {
          StatTracker.count("MapInteraction", "ClickToShowTravelTimePolygons");
          ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToShowTravelTimePolygons", { coord: [e.lngLat.lat, e.lngLat.lng] });
          CatchmentInterface.clearCache(); // clear cache as new point is selected
          catchmentStateDispatch(actionGenerateCatchmentSimple(catchmentState, mapitStateRef.current, new MitLatLng(e.lngLat.lat, e.lngLat.lng)));
          windowDispatch(openWindow(WindowId.CatchmentSelector, { latlng: new MitLatLng(e.lngLat.lat, e.lngLat.lng) }));
          windowDispatch(closeWindow(WindowId.PointDistanceTable));
          break;
        }
        case MapInteractionState.ClickToShowPointDistanceTable: {
          StatTracker.count("MapInteraction", "ClickToShowPointDistanceTable");
          ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToShowPointDistanceTable", { coord: [e.lngLat.lat, e.lngLat.lng] });
          windowDispatch(openWindow(WindowId.PointDistanceTable, { dialogMode: "PointToPoint", latlng: new MitLatLng(e.lngLat.lat, e.lngLat.lng) }));
          break;
        }

        case MapInteractionState.HentVurderingsEjendom: {
          StatTracker.count("MapInteraction", "HentVurderingsEjendom");
          ActionTracker.track("OnMapClick", "MapInteractionState", "HentVurderingsEjendom", { coord: [e.lngLat.lat, e.lngLat.lng] });
          findVurderingsEjendom(MitLatLng.fromM(e.lngLat)).then(({ sfe, geom }) => {
            Persistence.createLayersFromGeoJSON(sfe + " (vurd)", geom, new Date(), (li: LayerInfo) => { mapitStateDispatch({ type: MapitStateActionType.AddDataLayer, payload: { layerInfo: { ...li } } }) });
          })
          if (!e.originalEvent.ctrlKey)
            mapitStateDispatch(actionSetMapInteractionStateDefault());
          break;
        }
        case MapInteractionState.HentMatrikel: {
          StatTracker.count("MapInteraction", "HentMatrikel");
          ActionTracker.track("OnMapClick", "MapInteractionState", "HentMatrikel", { coord: [e.lngLat.lat, e.lngLat.lng] });
          visMatrikel(MitLatLng.fromM(e.lngLat))
          if (!e.originalEvent.ctrlKey)
            mapitStateDispatch(actionSetMapInteractionStateDefault());
          break;
        }
        case MapInteractionState.HentSamletFastEjendom: {
          StatTracker.count("MapInteraction", "HentSamletFastEjendom");
          ActionTracker.track("OnMapClick", "MapInteractionState", "HentSamletFastEjendom", { coord: [e.lngLat.lat, e.lngLat.lng] });
          visSamletFastEjendom(MitLatLng.fromM(e.lngLat))
          if (!e.originalEvent.ctrlKey)
            mapitStateDispatch(actionSetMapInteractionStateDefault());
          break;
        }
        case MapInteractionState.HistoriskeKort: {
          StatTracker.count("MapInteraction", "HistoriskeKort");
          ActionTracker.track("OnMapClick", "MapInteractionState", "HistoriskeKort", { coord: [e.lngLat.lat, e.lngLat.lng] });
          window.open(`https://historiskekort.dk/?geometri=POINT(${e.lngLat.lng}+${e.lngLat.lat})&limit=50&offset=0&sort=titel&direction=asc`)
          break;
        }
        case MapInteractionState.Override: {
          // Info: Used when logic lives outside MapScreen, eg Drawing
          break;
        }
        case MapInteractionState.EnforceFeatureLayerPopup: {
          StatTracker.count("MapInteraction", "EnforceFeatureLayerPopup");
          ActionTracker.track("OnMapClick", "MapInteractionState", "EnforceFeatureLayerPopup", { coord: [e.lngLat.lat, e.lngLat.lng] });
          ZoomPointViewAble(e.lngLat.lng, e.lngLat.lat);
          PopUpForSelectedLayers(mapitStateRef.current.selectedFeatureLayerKeys, e.lngLat);
          break;
        }
        case MapInteractionState.QueryFeatures: {
          StatTracker.count("MapInteraction", "QueryFeatures");
          ActionTracker.track("OnMapClick", "MapInteractionState", "QueryFeatures", { coord: [e.lngLat.lat, e.lngLat.lng] });
          const features = mapitStateRef.current.map.queryRenderedFeatures(e.point)
          console.info("Query", features)
          break;
        }
        case MapInteractionState.NSZoomedIn:
        case MapInteractionState.ZoomedIn:
        case MapInteractionState.Normal: {
          function clickDot(e, layerInfo) {
            if (layerInfo instanceof VectorLayer || layerInfo instanceof GeojsonWFS) {
              // vectorLayerClickFunction(e, layerInfo, (b) => mapitStateDispatch(actionAddPopup(MitLatLng.fromM(e.lngLat), (b), true)))
              return
            }
            DataLayerClickFunction(e, mapitState.mapInfo, layerInfo, (b) => mapitStateDispatch(actionAddPopup(MitLatLng.fromM(e.lngLat), (b), true)))
          }


          function clickHandler(e, layerInfo) {
            if (
              e.features?.[0]?.geometry?.type === "Point"
            ) {
              let [lng, lat, ..._] = e.features[0].geometry.coordinates
              e.lngLat = { lng: lng, lat: lat }
            }
            clickDot(e, layerInfo)
            if (e.originalEvent) e.originalEvent.stopPropagation();
          }

          function LayerInfoFromSourceID(sourceId: string) {
            return Object.values(mapitStateRef.current.layers).find((layerInfo) =>
              layerInfo.handle.sourceId == sourceId
            )
          }

          // TODO: Move logic for clicking data feature here, since it is already testing features under mouse
          const activeLayers = Object.keys(mapitStateRef.current.layers).flatMap((a) => {
            return mapitStateRef.current.layers[a].handle.layerList.filter(a => {
              return a.type !== "fill-extrusion" && !a.id.includes("fill-text")
            }).map(a => a.id)
          })
          let firstAccepted = false
          const featuresUnderMouse = mapitStateRef.current.map.queryRenderedFeatures(e.point)
          const dataFeautesUnderMouse = featuresUnderMouse.filter((a) => activeLayers.includes(a.layer.id)).map((a) => {
            if (firstAccepted) {
              return a.layer.id
            }
            clickHandler({ ...e, features: [a] }, LayerInfoFromSourceID(a.layer.source))
            firstAccepted = true;
            return a.layer.id
          })
          const activeVectorFeatures = mapitStateRef.current.selectedFeatureLayerKeys.filter((a) => {
            return (mapitStateRef.current.featureLayers[a] instanceof VectorLayer || mapitStateRef.current.featureLayers[a] instanceof GeojsonWFS)
          }).map((a) => (mapitStateRef.current.featureLayers[a] as VectorLayer).getLayerID(0))
          const vectorFeaturesUnderMouse = featuresUnderMouse.filter((a) => activeVectorFeatures.includes(a.layer.id)).map((a) => {
            return a
          })
          if (dataFeautesUnderMouse.length) {
            return
          }
          if (vectorFeaturesUnderMouse?.length) {
            vectorLayerClickFunction(e.lngLat, vectorFeaturesUnderMouse, (b) => mapitStateDispatch(actionAddPopup(MitLatLng.fromM(e.lngLat), (b), true)))
          }

          if (dataFeautesUnderMouse.length + vectorFeaturesUnderMouse.length === 0)
            if (mapitStateRef.current.selectedFeatureLayerKeys.length
              && (e.originalEvent?.altKey
                || !hasAccessToFeature(Feature.ThemeNewSec))) {
              ZoomPointViewAble(e.lngLat.lng, e.lngLat.lat)
              PopUpForSelectedLayers(mapitStateRef.current.selectedFeatureLayerKeys, e.lngLat);
            } else if (mapitStateRef.current.map.getZoom() > SettingsManager.getSystemSetting("mapInteractionStateZoomedIn")) {
              if (hasAccessToFeature(Feature.ThemeNewSec)) {
                let latLng = new MitLatLng(e.lngLat.lat, e.lngLat.lng)
                let resp = await AddressInterface.reverseGeocode(e.lngLat.lat, e.lngLat.lng);
                let addrData = await resp.json();
                let fullAddress = addrData.betegnelse;
                let tmp = fullAddress.split(',');
                let streetAndNumber = tmp[0] || fullAddress;
                let layerInfo = LayerFunc.createLayerInfoForOnePoint(latLng, streetAndNumber);
                DataLayerClickFunction({ ...e, features: [{ geometry: { type: "Point" } }] }, mapitState.mapInfo, layerInfo, (b) => mapitStateDispatch(actionAddPopup(MitLatLng.fromM(e.lngLat), (b), true)))
                break;
              }
              if (hasAccessToFeature(Feature.PropertyInfo)) {
                if (SettingsManager.getSystemSetting("showPropertyInfoOnClick", true)) {
                  StatTracker.count("MapInteraction", "ClickToShowPropertyInfo");
                  ActionTracker.track("OnMapClick", "MapInteractionState", "ClickToShowPropertyInfo", { coord: [e.lngLat.lat, e.lngLat.lng] });
                  let bfeData = await DC.WFS.Utils.bfeUnderPoint([e.lngLat.lng, e.lngLat.lat]);
                  windowDispatch(openWindow(WindowId.PropertyInformationDialog, { bfeNr: bfeData?.sfeNr, ejerlavskode: bfeData?.ejerl, matrnr: bfeData?.matnr }));
                }
              }
              break;
            }
          break;
        }

        default: {
          throw new Error("Unexpected MapinterationState: " + mapInteractionStateRef.current);
        }
      }
    }
  }

  function PopUpForSelectedLayers(SelectedLayers, lngLat: { lat: number, lng: number }) {
    let activeFeatures: FeatureLayer[] = SelectedLayers.map((a) => mapitStateRef.current.featureLayers[a])
    pointInfoDotFunction(lngLat, activeFeatures, (b) => mapitStateDispatch(actionAddPopup(MitLatLng.fromL(lngLat), (b), true)))
  }

  function closeIt() {
    return "Any string value here forces a dialog box to \n" +
      "appear before closing the window.";
  }

  // Menu event handlers
  // -----------------------------------------------------------------------------------------------


  function buttonClickedShowLegend() {
    // setState({showLegend:true});
    windowDispatch(openWindow(WindowId.Legend));
  }

  function callbackToHideLegend() {
    // setState({showLegend:false});
    windowDispatch(closeWindow(WindowId.Legend));
  }


  // -----------------------------------------------------------------------------------------------
  /**
 * Add a new layer
 * @param map The map object
 * @param layerInfo The layerInfo for the layer to create
 * @param zoomToFocus if true the screen is zoomed after the layer is created
 */
  function addALayer(map: MitMap, layerInfo: LayerInfo, zoomToFocus: boolean) {
    mapitStateDispatch(actionAddDataLayer(layerInfo, zoomToFocus, true));
  }

  // -------------------------------------------------------

  async function visSamletFastEjendom(latLng: MitLatLng): Promise<void> {
    try {
      let utmCoords = GenerateGeom.convertFromLatLngToUTM(latLng);
      appMessageDispatch(actionSetInfoMessage(Localization.getText("Retrieving cadaster data")));
      let matrikelData = await PropertyInfoInterface.getMatrikelData(utmCoords)
        .then(result => {
          let props = result.features[0].properties;
          return {
            sfeEjdNr: props.samletfastejendomlokalid,
          };
        }).
        catch(() => {
          appMessageDispatch(actionSetErrorMessage(Localization.getText("Cannot display cadaster information for this point")));
          return undefined;
        });
      if (matrikelData && matrikelData.sfeEjdNr) {
        appMessageDispatch(actionSetInfoMessage(Localization.getText("Retrieving geometry data")));
        let geoJson = await PropertyInfoInterface.getGeojsonOfSFE(matrikelData.sfeEjdNr)
          .then(result => result)
          .catch(() => {
            appMessageDispatch(actionSetErrorMessage(Localization.getText("No geometry data for this property")));
            return undefined;
          });
        geoJson.type = "FeatureCollection"
        Persistence.createLayersFromGeoJSON((matrikelData.sfeEjdNr) + " (sfe)", geoJson, new Date(), (li: LayerInfo) => { mapitStateDispatch({ type: MapitStateActionType.AddDataLayer, payload: { layerInfo: { ...li, propertiesToDisplay: [{ name: "SFEnummer" }] } } }) });
        appMessageDispatch(actionClearInfoMessage());
      } else {
        appMessageDispatch(actionSetErrorMessage(Localization.getText("No cadaster data for this point")));
      }
    } catch {
      appMessageDispatch(actionSetErrorMessage(Localization.getText("Cannot display cadaster information for this point")));
    }
  }

  async function visMatrikel(latLng: MitLatLng) {
    try {
      let data = await PropertyInfoInterface.getMatrikelFromPoint(latLng)
      if (data.features.length == 1) {
        let props = data.features[0].properties;
        data.features[0].properties = {
          "Matrikelnummer": props.matrikelnummer,
          "Ejerlav": await EjerlavCache.get(props.ejerlavskode),
          "Ejerlavskode": props.ejerlavskode,
          "SFEnummer": props.samletFastEjendomLokalId,
          "Areal": props.registreretAreal,
          "Vejareal": props.vejareal,
        }
        let keys = Object.keys(data.features[0].properties).map((a) => ({ name: a }));
        let ejerlav = (props.ejerlavskode);
        let layername = props.matrikelnummer + ", " + ejerlav;
        Persistence.createLayersFromGeoJSON(layername, data, new Date(), (li: LayerInfo) => { mapitStateDispatch({ type: MapitStateActionType.AddDataLayer, payload: { layerInfo: { ...li, propertiesToDisplay: keys } } }) });
      }
    } catch (error: any) {
      if (error.message.includes("Failed to fetch")) {
        appMessageDispatch(actionSetErrorMessage(Localization.getText("Cannot connect to the required service")));
        return
      }
      appMessageDispatch(actionSetErrorMessage(Localization.getText("Cannot display cadaster information for this point")));
    }
  }

  async function findVurderingsEjendom(latLng: MitLatLng): Promise<{ sfe: string, geom: any }> {
    let bfeNr = (await DC.WFS.Utils.bfeUnderPoint([latLng.lng, latLng.lat])).sfeNr;
    if (!bfeNr) {
      throw new Error("No property found under point");
    }
    let ejendommeIVurdering = await DC.DF_GQL.VURD.EjendommeVurderetUnderBFE(bfeNr + "");
    if (!ejendommeIVurdering || ejendommeIVurdering.length === 0) {
      ejendommeIVurdering = [bfeNr + ""]
    }
    let samletGeometry = await DC.WFS.getFeatureQuery("Matriklen2", "Jordstykke_Gaeldende",
      `samletFastEjendomLokalId in (${ejendommeIVurdering.map((a) => `'${a}'`).join(",")})`
    )
    console.log("Samlet geometry for vurderingsejendom:", samletGeometry)
    return { sfe: bfeNr, geom: samletGeometry };
  }

  // ---------------- RENDERING -----------------------


  /* tslint:disable */

  // When legend is deliberately hidden show a button to re-display. (Legend is also automatically hidden when no layers requireing a legend exists)
  let buttonToRedisplayLegend = windowState.find((e) => e.id == WindowId.Legend) || (applicationState.appMode === AppMode.Embedded) ? null : (
    <OnMapButton
      title-placement='right'
      className="ReOpenLegend" title={Localization.getText("Show Legend")} onClick={() => buttonClickedShowLegend()} style={{ position: "absolute", bottom: "15px", left: "10px" }}>
      <MIBIcon icon="legend" />
    </OnMapButton>
  );
  let otherLegends: { [legendId: string]: OtherLegendSpec } = {
    "CatchmentEditable": {
      renderLegend: () => {
        return (
          <div className={"Group"} key={"CatchmentEditable"}>
            <div className={"Line"}>
              <div className='TitleIcon'>
                <Catchment />
              </div>
              <div className='Title'>
                {Localization.getText("Travel time") + " (min)"}
              </div>

            </div>
            <LegendScaleForCatchment />
          </div>
        )
      },
      showLegend: () => {
        return Boolean(windowState.find((e) => e.id == WindowId.CatchmentSelector));
      }
    },
    "FRPLegend": {
      renderLegend: () => {
        return (
          <div className={"Group"} key={"FRPLegend"}>
            <div className={"Line"}>
              <div className='TitleIcon'>
                <StatusUp size="16" />
              </div>
              <div className='Title'>
                <b>{Localization.getText("Visualization")}</b>
              </div>
            </div>
            <FRPLegendList />
          </div>
        )
      },
      showLegend: () => {
        return Boolean(windowState.find((e) => e.id == WindowId.FRPAnnoteringsDialog));
      }
    },
    "JPBLegend": {
      renderLegend: () => {
        return <JPBLegendList />;
      },
      showLegend: () => {
        return Boolean(windowState.find((e) => e.id == WindowId.JPBTool));
      }
    }

  };


  // Add flexible background layers to legend.
  let featureLayers: FeatureLayerList = mapitState.featureLayers;

  let OrderInDrawinOrder = SettingsManager.getSystemSetting("OrderBackgroundLayersInDrawingOrder")
  let selectedKeys = mapitState.selectedFeatureLayerKeys.toReversed()
  let OrderedLegendKeys = OrderInDrawinOrder ? selectedKeys : Object.keys(featureLayers);
  OrderedLegendKeys.forEach((key) => {
    let lgend: OtherLegendSpec = {
      renderLegend: () => {
        if (featureLayers[key]) {
          return <BackgroundLayerCompLegend key={key} flayer={featureLayers[key]} map={mapitState.map} />;
        }
      },
      showLegend: () => {
        if (featureLayers[key] && selectedKeys.includes(key)) {
          return featureLayers?.[key]?.layer && !("noLegend" in featureLayers[key].layer && featureLayers[key].layer.noLegend);
        }
        return false;
      }
    };
    otherLegends[key] = lgend;
  });


  let layerArray = Object.values(mapitState.layers).filter(layer => layer.layerVariability !== LayerVariabilityType.FixedFeatureLayer);
  // MARK: Render
  return (
    <div id="mapUI" className="App2">
      <div id="mit-mainwindow-map">
        <div className='MouseBox' id='FillExtrusionDetail' />
        {createPortal(
          <>
            {buttonToRedisplayLegend}
            <Legend
              showWindow={windowState.find((e) => e.id == WindowId.Legend) ? 1 : 0}
              layers={layerArray}
              layerHiearchy={mapitState.layerHierarchy}
              callBackOnStyleChange={(layerInfo: LayerInfo) => {
                mapitStateDispatch(actionRemoveDataLayer(layerInfo.layerId, true));
                mapitStateDispatch(actionAddDataLayer(layerInfo, false, true));
                return layerInfo.layerId
              }}
              callBackToHideWindow={() => callbackToHideLegend()}
              otherLegends={otherLegends}
            />
          </>
          , document.getElementById("Mit-MapOverlay") || document.body)}

        <div ref={mapContainer} id="map" className='MapScreen-Container' />
        <CookieApproval />
        {/* <QuickOrthoPhoto /> */}
        <div className="dropContainer" id="dropContainer" />
      </div>
      <CustomerLogo
        customerIconURL={mapitState.mapInfo.customerIconURL!}
        customerIconLink={mapitState.mapInfo.customerIconLink!}
      />
      <PopupHandler popups={mapitState.mapPopout} />

    </div>
  );
}


function PopupHandler(props: { popups: MitPopup[] }) {
  return (
    <>
      {props.popups.map((a) => {
        return createPortal(a.content, a.container, a.key)
      })}
    </>
  )
}


export default MapScreen;
// MARK: Datalayer Popups
export function DataLayerClickFunction(e: any, mapInfo: MapInfo, layerInfo: LayerInfo, callBackJSX: (a: JSX.Element) => void) {
  let coordinates = e && e.lngLat;
  while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
  }

  const type = e.features[0].geometry.type;
  switch (GeoJsonTypeToPopupType(type)) {
    case 'Point': {
      callBackJSX(<PointPopup layerInfo={layerInfo} feature={e.features[0]} lat={coordinates.lat} lng={coordinates.lng} />)
      break;
    }
    case 'Line': {
      callBackJSX(<LinePopup layerInfo={layerInfo} feature={e.features[0]} />)
      break;
    }
    case 'Area': {
      callBackJSX(<AreaPopup layerInfo={layerInfo} feature={e.features[0]} />)
      break;
    }
  }
}

function vectorLayerClickFunction(lngLat: { lng: number, lat: number }, layers: any[], callBackJSX: (a: JSX.Element) => void) {
  callBackJSX(<VectorLayerPopup vectorFeatures={layers} lngLat={lngLat} />)
}

function pointInfoDotFunction(lngLat: { lng: number, lat: number }, flayer: FeatureLayer[], callBackJSX: (a: JSX.Element) => void) {
  callBackJSX(<PointInfoPopup lngLat={lngLat} layers={flayer} />)
}

function BackgroundLayerCompLegend(props: { flayer: FeatureLayer, map: any }) {
  const [zoom, setZoom] = useState(0);

  const ftl = props.flayer.layer;

  // Manage multiple layers
  const cLegend = props.flayer.getCLegend();
  const url = props.flayer.getLegendURL?.() || "";
  const opacity = props.flayer.getOpacity()
  const legendCrop = ftl.legendCrop
  const legendOffset = ftl.legendOffset
  const legendHueRotate = ftl.paint?.["raster-hue-rotate"];
  const legendSaturate = (ftl.paint?.["raster-saturation"] || 0) + 1

  useEffect(() => {
    if (props.map) {
      function zoomEnd(e) {
        setZoom(e.target.getZoom())
      }
      props.map.on("zoomend", zoomEnd)
      return () => {
        props.map.off("zoomend", zoomEnd)
      }
    }
  }, [props.map])

  if (zoom && ftl.minZoom > zoom) {
    return (
      <div className="Group" key={ftl.label}>
        <div className="Line">
          <div className="TitleIcon"><MIBIcon icon="layer" /></div>
          <div className='Title' >
            {ftl.translationTable ? Localization.getTextSpecificTable(ftl.label, ftl.translationTable) : ftl.label}
          </div>
        </div>
        <div className='Group'>
          <MIBIcon icon="layerWarning" style={{ verticalAlign: "sub", fontSize: "14px", marginRight: "0.5em" }} />{Localization.getText("Zoom in to show")}
        </div>
      </div>
    )
  }
  if (cLegend) {
    return (
      <div className="Group" key={ftl.label}>
        <div className="Line">
          <div className="TitleIcon"><MIBIcon icon="layer" /></div>
          <div className='Title' >
            {ftl.translationTable ? Localization.getTextSpecificTable(ftl.label, ftl.translationTable) : ftl.label}
          </div>
        </div>
        <div className="Group" >
          {cLegend.map((a, idx) => {
            let label = a[Localization.getLanguage()] || a["dk"] || a["en"] || "";

            return (
              <div key={idx} className="LegendImg" style={{ maxHeight: (legendCrop ? legendCrop + "px" : "none") }} >
                {a.ico ? <MitPatt opacity={opacity} pattern={a.ico} /> : null}
                <div className="LegendImgText">
                  {label}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  if ((props.flayer instanceof VectorLayer || props.flayer instanceof GeojsonWFS) && url) {
    const layer = props.flayer;
    return (
      <div className="Group" key={ftl.label}>
        <div className="Line">
          <div className="TitleIcon"><MIBIcon icon="layer" /></div>
          <div className='Title' >
            {ftl.translationTable ? Localization.getTextSpecificTable(ftl.label, ftl.translationTable) : ftl.label}
          </div>
        </div>
        <div className="Group">
          <div key={layer.getLegendURL()} className="LegendImg" style={{ maxHeight: (legendCrop ? legendCrop + "px" : "none") }} >
            <Image
              style={{ objectFit: "none", marginTop: (legendOffset || 0) + "px", filter: ` hue-rotate(${legendHueRotate || 0}deg) saturate(${legendSaturate})` }}
              className="mit-legend-ows"
              src={layer.getLegendURL()}
              fluid={true}
            />
          </div>
        </div>
      </div>)
  }
  if (!("noLegend" in ftl && ftl.noLegend === true) && url) {
    return (
      <div className="Group" key={ftl.label}>
        <div className="Line">
          <div className="TitleIcon"><MIBIcon icon="layer" /></div>
          <div className="Title" >
            {ftl.translationTable ? Localization.getTextSpecificTable(ftl.label, ftl.translationTable) : ftl.label}
          </div>
        </div>
        <div className="Group" >
          {ftl.layers.split(",").map((a) => url.replace(ftl.layers, a)).filter((a, b) => !ftl.legendExclude?.includes(b)).map((imgUrl, idx) =>
            <div key={imgUrl} className="LegendImg" style={{ maxHeight: (legendCrop ? legendCrop + "px" : "none") }} >
              <Image
                style={{ objectFit: "none", marginTop: (legendOffset || 0) + "px", filter: ` hue-rotate(${legendHueRotate || 0}deg) saturate(${legendSaturate})` }}
                className="mit-legend-ows"
                src={imgUrl!}
                fluid={true}
              />
              <div className="LegendImgText">
                {ftl.legendLabels?.[Localization.getLanguage()][idx]}
              </div>
            </div>
          )}
        </div>
      </div>)
  }
  return null

}

const PointsInGeoJson = {
  "Point": "Point",
  "MultiPoint": "Point",
  "MultiLineString": "Line",
  "LineString": "Line",
} as const
function GeoJsonTypeToPopupType(type: string): "Point" | "Line" | "Area" {
  return PointsInGeoJson[type] ?? "Area"
}

function MitPatt(props: { pattern: string, opacity?: number }) {
  let [imgUrl, setImgUrl] = useState<string>("");

  useEffect(() => {
    GenerateGeom.getEveryMitPattern(props.pattern, (url) => {
      setImgUrl(url);
    });
  }, [props.pattern])

  return (
    <div style={{ width: "20px", height: "20px", backgroundColor: "white", marginLeft: "2px", marginRight: "0px", borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: "2px" }}>
      <div style={{ width: "100%", height: "100%", backgroundImage: `url(${imgUrl})`, backgroundSize: "cover", opacity: props.opacity ?? 1 }}></div>
    </div>
  )
}

function safeJSONParse(str: string): any | undefined {
  try {
    return JSON.parse(str);
  } catch {
    return undefined;
  }
}

function validGeojson(geoObj: unknown): boolean {
  if (
    typeof geoObj !== "object" ||
    geoObj === null ||
    geoObj === undefined ||
    !("type" in geoObj) ||
    !(geoObj.type == "Feature" || geoObj.type == "FeatureCollection")
  ) {
    return false
  }
  return true
}
